export const MEAL_TITLES = {
  AI: 'все включено',
  BB: 'завтраки',
  FB: 'завтраки, обеды, ужины',
  'FB+': 'завтраки, обеды, ужины - расширенное меню',
  HB: 'завтраки, ужины',
  'HB+': 'завтраки, ужины - расширенное меню',
  RO: 'без питания',
  UAI: 'ультра все включено',
};